import React from "react";

import LandingPage from "../pages/LandingPage/LandingPage";
import About from "../pages/About/About";
import Contact from "../pages/Contact/Contact";
import Careers from "../pages/Careers/Careers";
import Privacy from "../pages/Privacy/Privacy";
import Terms from "../pages/Terms/Terms";
import PageNotFound from "../error/PageNotFound";

const configureRoutes = () => {
  const routes = [
    {
      path: "/",
      type: "public",
      element: <LandingPage />,
    },

    {
      path: "/about",
      type: "public",
      element: <About />,
    },

    {
      path: "/contact",
      type: "public",
      element: <Contact />,
    },

    {
      path: "/careers",
      type: "public",
      element: <Careers />,
    },

    {
      path: "/privacy",
      type: "public",
      element: <Privacy />,
    },

    {
      path: "/terms",
      type: "public",
      element: <Terms />,
    },

    // 404 - Unknown routes
    {
      path: "*",
      type: "error",
      element: <PageNotFound />,
    },
  ];

  return routes;
};

export default configureRoutes;